export const POST_SIGN_IN_PATH = "/postsignin";

/** Default return path when sign-in was not started from a specific page. */
export function getSignInReturnPath(explicitReturn?: string | null): string {
  if (explicitReturn && explicitReturn.length > 0) {
    const path = explicitReturn.startsWith("/") ? explicitReturn : "/" + explicitReturn;
    if (path !== "/" && path !== POST_SIGN_IN_PATH) {
      return path;
    }
  }
  return POST_SIGN_IN_PATH;
}

export function postSignInDestination(bought: boolean): string {
  return bought ? "/userinfo" : "/buy";
}
